module.exports = __webpack_public_path__ + "static/media/borzo.5950cf60.webp";